import React from "react";
import { connect } from 'react-redux';
import "./ElementDropItem.css";
import { cmsHelper } from "../../../helpers/cmsHelper";
import { sourceTypes } from "../../../../constants/cms/sourceType";

const ElementDropItemWithImage = ({
    name,
    thumbnail,
    userLabel = false,
    draggableId,
    enviroment,
    source,
    dispatch, listElements,
    customStyle = {},
}) => {
    const addOnClick = () => {
        cmsHelper.addElementByClick(enviroment, listElements, source, draggableId, dispatch)
    }
    return (
        <div style={customStyle} className={'element-drop-item image-item'}>
            {thumbnail}
            <div
                style={{
                    color: "#222",
                    fontWeight: "600",
                    fontSize: "10px",
                    color: "rgb(81, 97, 103)",
                    textTransform: "uppercase",
                    borderBottom: "0px !important",
                    wordBreak: "break-word",
                    maxWidth: '140px'
                }}
            >
                {enviroment !== sourceTypes.TEMPLATE && enviroment !== sourceTypes.EMAIL ? <div className="quick-add" onClick={addOnClick} ><i style={{ fontSize: "12px", color: '#fff' }} className="fa fa-plus" /></div> : null}
            </div>
        </div>
    );
};



function mapStateToProps(state) {
    const { enviroment } = state.cms;
    let activeElements = null;
    let source = null;
    if (enviroment === sourceTypes.FORM) {
        activeElements = state.form.formElements;
        source = state.form;
    }
    if (enviroment === sourceTypes.PAGE) {
        activeElements = state.page.pageElements;
        source = state.page;
    }
    return {
        template: state.template,
        source,
        activeElements,
        listElements: state.element.elements,
        enviroment
    };
}

export default connect(mapStateToProps)(ElementDropItemWithImage);